/**
 * Trust Badges Dropdown Functionality
 * Shows only 4 trust badges initially with dropdown to reveal more
 */

class TrustBadgesDropdown {
  constructor() {
    this.container = null;
    this.badgesList = null;
    this.toggleButton = null;
    this.isExpanded = false;
    this.minVisibleBadges = 4;
    
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    this.container = document.querySelector('.pdp-custom-trust-badges-container');
    this.badgesList = document.querySelector('.prebook-product-description-details_container');
    
    if (!this.container || !this.badgesList) {
      return; // No trust badges found
    }

    const badges = this.badgesList.querySelectorAll('.prebook-product-description_info');
    
    // Only setup dropdown if there are more than 4 badges
    if (badges.length <= this.minVisibleBadges) {
      this.container.classList.add('no-dropdown');
      return;
    }

    this.setupDropdown();
    this.bindEvents();
  }

  setupDropdown() {
    // Add classes for styling
    this.container.classList.add('has-dropdown');
    // Don't add collapsed class initially since CSS already hides extra badges

    // Create dropdown toggle button
    this.createToggleButton();
    
    // Create gradient overlay
    this.createGradientOverlay();
  }

  createToggleButton() {
    this.toggleButton = document.createElement('button');
    this.toggleButton.className = 'trust-badges-dropdown-toggle';
    this.toggleButton.setAttribute('aria-expanded', 'false');
    this.toggleButton.setAttribute('aria-label', 'Read more trust badges');
    
    // Create button content
    const buttonText = document.createElement('span');
    buttonText.textContent = 'Read more';
    
    this.toggleButton.appendChild(buttonText);
    
    // Insert button after the badges list
    this.container.appendChild(this.toggleButton);
  }

  createGradientOverlay() {
    // Removed gradient overlay since we're using different positioning approach
  }

  getArrowSVG() {
    return `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 6L8 10L12 6" stroke="#382521" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
  }

  bindEvents() {
    if (this.toggleButton) {
      this.toggleButton.addEventListener('click', () => this.toggle());
    }
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
    
    if (this.isExpanded) {
      this.expand();
    } else {
      this.collapse();
    }
  }

  expand() {
    this.badgesList.classList.add('expanded');
    this.toggleButton.classList.add('expanded');
    this.toggleButton.setAttribute('aria-expanded', 'true');
    this.toggleButton.querySelector('span').textContent = 'Show Less';
    this.toggleButton.setAttribute('aria-label', 'Show fewer trust badges');
    this.isExpanded = true;
  }

  collapse() {
    this.badgesList.classList.remove('expanded');
    this.toggleButton.classList.remove('expanded');
    this.toggleButton.setAttribute('aria-expanded', 'false');
    this.toggleButton.querySelector('span').textContent = 'Read more';
    this.toggleButton.setAttribute('aria-label', 'Read more trust badges');
    this.isExpanded = false;
    
    // Remove automatic scrolling - let user stay where they are
  }

  // Public method to refresh the dropdown (useful for dynamic content)
  refresh() {
    // Remove existing dropdown elements
    const existingToggle = this.container.querySelector('.trust-badges-dropdown-toggle');
    const existingOverlay = this.container.querySelector('.trust-badges-gradient-overlay');
    
    if (existingToggle) existingToggle.remove();
    if (existingOverlay) existingOverlay.remove();
    
    // Reset classes
    this.container.classList.remove('has-dropdown', 'no-dropdown');
    this.badgesList.classList.remove('collapsed', 'expanded');
    
    // Re-setup
    this.setup();
  }
}

// Initialize when script loads
new TrustBadgesDropdown();

// Export for potential external use
window.TrustBadgesDropdown = TrustBadgesDropdown;
